import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment';
import React from 'react';

const UnapproveAllDialog = ({ dialogOpen, setDialogOpen, action, date, paymentType, reportTypeText }) => {
    const performAction = async () => {
        action();
        setDialogOpen(false);
    };
    return (
        <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="sm">
            <DialogTitle id="draggable-dialog-title">Confirm</DialogTitle>
            <DialogContent>
                <DialogContentText className="text-black">
                    Are you sure you want to unapprove all {date} {paymentType} {reportTypeText ?? 'producer'} pay statements?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => performAction()} variant="contained" color="primary">
                    Confirm
                </Button>
                <Button onClick={() => setDialogOpen(false)} color="primary">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UnapproveAllDialog;
